module.exports = __webpack_public_path__ + "img/Support-skill-220.d9857205.png";